import React from 'react'
import { useToggle } from 'react-use'
import { useUser } from '@ztechapps/common.hook'
import { ShowIf } from '@ztechapps/webui.util'

import { BusyButton } from '@ztechapps/webui.button'
import { ChangePassword as ChangePasswordCore } from '@ztechapps/webui.auth'
import { appSettings } from '../../../config/settings'
import { routesDef } from '../../../config/routes'

export const ChangePassword = () => {
  const [showChangePassword, setShowChangePassword] = useToggle(false)
  const { user } = useUser()
  const recaptchaSiteKey = appSettings.Google.recaptchaSiteKey

  return (
    <div>
      <ShowIf condition={showChangePassword}>
        <ChangePasswordCore
          withCurrentPasswordForm={true}
          url={`/api/auth/basic/pp-store/change-password-with-current-password-validation`}
          userId={user?._id}
          components={{
            cancelButton: () => <BusyButton text={'Cancel'} onClick={setShowChangePassword} />,
          }}
          recaptchaSiteKey={recaptchaSiteKey}
          navigateTo={routesDef.LoginPage.altPath()}
        />
      </ShowIf>

      <ShowIf condition={!showChangePassword}>
        <BusyButton text={'Change password'} onClick={setShowChangePassword} />
      </ShowIf>
    </div>
  )
}
